export enum PointDrillPileStatus {
  Ok = 'OK',
  Log = 'Log',
  Entry = 'Entry',
  Start = 'Start',
  Paused = 'Pause',
  End = 'End',
  Failed = 'Failed',
  Continue = 'Continue'
}